import { FETCH_FOOTER_DATA } from './constants'

export const fetchFooter = {
  request: (language, version) => ({ type: FETCH_FOOTER_DATA['REQUEST'], language, version }),
  success: footer => ({
    type: FETCH_FOOTER_DATA['SUCCESS'],
    footer
  }),
  failure: error => ({
    type: FETCH_FOOTER_DATA['FAILURE'],
    error
  })
}



// WEBPACK FOOTER //
// ./src/containers/Footer/actions.js